"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _react2 = require("@emotion/react");

var _ProgressCircle = require("./ProgressCircle.styles");

var _theme = require("../../util/theme");

var Circle = (0, _base["default"])("span", {
  target: "e1o6zn3y0",
  label: "Circle"
})(_ProgressCircle.styles.circle, ";");

var ProgressCircle = function ProgressCircle(_ref) {
  var color = _ref.color,
      rippleColor = _ref.rippleColor,
      className = _ref.className;
  var theme = (0, _react2.useTheme)();
  var colorValue = (0, _react.useMemo)(function () {
    return (0, _theme.themeValLookup)(color)({
      theme: theme
    }) || color;
  }, [color, theme]);
  var rippleColorValue = (0, _react.useMemo)(function () {
    return (0, _theme.themeValLookup)(rippleColor)({
      theme: theme
    }) || rippleColor;
  }, [rippleColor, theme]);
  return (0, _jsxRuntime.jsx)(Circle, {
    color: colorValue,
    rippleColor: rippleColorValue,
    className: className
  });
};

ProgressCircle.propTypes = {
  color: _propTypes.string,
  rippleColor: _propTypes.string,
  className: _propTypes.string
};
ProgressCircle.defaultProps = {
  color: 'color.primary.info',
  rippleColor: 'color.secondary.info',
  className: undefined
};
var _default = ProgressCircle;
exports["default"] = _default;
//# sourceMappingURL=ProgressCircle.js.map